import dayjs from 'dayjs';

export default function getOnRuleChange(
  rulesData,
  unifiedList,
  form,
  setIsUnifiedDeleted
) {
  if (rulesData) {
    const startDate = dayjs(rulesData.rule_plan_start_date);
    const endDate = dayjs(rulesData.rule_plan_end_date);
    const nonDeletedUni = unifiedList?.find(
      (option) => option.value === rulesData?.unified_source_master_id
    );
    form.setFieldsValue({
      ...rulesData,
      rule_plans_date: [startDate, endDate],
      unified_source_master_id: nonDeletedUni
        ? nonDeletedUni?.value
        : undefined,
    });
    setIsUnifiedDeleted(!form.getFieldValue('unified_source_master_id'));
  }
}
